import { render, staticRenderFns } from "./ReadOnlyEditor.vue?vue&type=template&id=a279db0c&"
import script from "./ReadOnlyEditor.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReadOnlyEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a279db0c')) {
      api.createRecord('a279db0c', component.options)
    } else {
      api.reload('a279db0c', component.options)
    }
    module.hot.accept("./ReadOnlyEditor.vue?vue&type=template&id=a279db0c&", function () {
      api.rerender('a279db0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/ReadOnlyEditor.vue"
export default component.exports